import template from './truck.all.html';
import controller from './truck.all.controller';
import './truck.all.scss';

let truckallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default truckallComponent;


// WEBPACK FOOTER //
// ./client/app/components/truck/all/truck.all.component.js